module.exports = __webpack_public_path__ + "img/38_33.208267c2.png";